import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Typography,
  Button,
  Grid,
  TextField,
  Tooltip,
  IconButton,
  Box,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { getData, putData } from "../../../../../services/library";
import DetallePedido from "../../../pedidosEnvasado/DetallePedido";
import PedidoCliente from "./PedidoCliente";
import { useFechas } from "../../../pedidosEnvasado/context/FechaContext";
import RefreshIcon from "@mui/icons-material/Refresh";
import AnularFactura from "../../../facturados/anularFactura/AnularFactura";
import { verEnviarPDFenvasado } from "../../../../../services/services";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import BlockIcon from "@mui/icons-material/Block";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

function PedidosFicha(props) {
  const { desde, hasta, setDesde, setHasta } = useFechas();
  const [pedidos, setPedidos] = useState();
  const [cliente, setCliente] = useState(props.cliente);
  const [nuevoPedido, setNuevoPedido] = useState(false);
  const [anularFactura, setAnularFactura] = useState(false);
  const [rowFactura, setRowFactura] = useState();

  const handleClickNuevopedido = () => {
    setNuevoPedido(true);
  };

  useEffect(() => {
    getData("/envasado_pedidos/xclientefecha/" + props.cliente.id + "/"+
      desde +
      " 00:00:00/" +
      hasta +
      " 23:59:59/", 
      setPedidos);
  }, []);

  const actualizar = () => {
    getData("/envasado_pedidos/xclientefecha/" + props.cliente.id + "/"+
      desde +
      " 00:00:00/" +
      hasta +
      " 23:59:59/", 
      setPedidos);
  };

  const handleActualizar = () => {
    actualizar();
  };

  const handleCloseAnular = () => {
    setAnularFactura(false);
    actualizar();
  };

  const handleAnularFactura = (row) => {
    setAnularFactura(true);
    setRowFactura(row);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 20,
      },
      {
        accessorKey: "direccion_entrega", //access nested data with dot notation
        header: "Dirección Entrega",
        size: 400,
      },
      {
        accessorKey: "valor", //access nested data with dot notation
        header: "Estado",
        size: 200,
      },
      {
        accessorKey: "fecha_para", //access nested data with dot notation
        header: "Para Fecha",
        size: 100,
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F5") {
        event.preventDefault();
        handleClickNuevopedido();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };
  return (
    <div>
      <Container maxWidth="xl" disableGutters sx={{ mb: 1 }}>
        <MaterialReactTable
          columns={columns}
          data={pedidos ?? [{}]}
          layoutMode={"grid"}
          initialState={initialState}
          enableColumnActions={false} //deshabilita las acciones POR COLUMNA
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableRowActions={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn={"last"}
          enableExpandAll={false}
          localization={customLocalization}
          enableToolbarInternalActions={true}
          muiTableHeadCellProps={tableHeadCellProps}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          enableDensityToggle={false}
          displayColumnDefOptions={displayColumnDefOptions}
          enableColumnResizing={true}
          renderDetailPanel={({ row }) => <DetallePedido row={row.original} />}
          muiTableBodyCellProps={({ row }) => ({
            align: "left",
          })}
          renderTopToolbarCustomActions={() => (
            <>
              <Box display="flex" alignItems="center" gap={1} ml={1}>
                <TextField
                  size="small"
                  label="Desde"
                  type="date"
                  value={desde}
                  onChange={(e) => setDesde(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  size="small"
                  label="Hasta"
                  type="date"
                  value={hasta}
                  onChange={(e) => setHasta(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <Tooltip title="Actualizar">
                  <IconButton
                    onClick={handleActualizar}
                    sx={{
                      backgroundColor: "#e0e0e0",
                      "&:hover": { backgroundColor: "#d5d5d5" },
                    }}
                  >
                    <RefreshIcon sx={{ color: "#333" }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </>
          )}
                    renderRowActions={({ row }) => {
            const estado = row.original.estado;

            return (
              <Box sx={{ display: "flex", gap: "4px" }}>
                {(row.original.estado === 311 || row.original.estado === 312 ||
                  row.original.estado === 328 ||
                  row.original.estado === 355) && (
                  <Tooltip title="Ver Factura" placement="top">
                    <IconButton
                      onClick={() =>
                        verEnviarPDFenvasado(row.original.id_factura, 0)
                      }
                    >
                      <RemoveRedEyeIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                )}

                {row.original.estado === 328 && (
                  <Tooltip title="Ver Nota de Credito" placement="bottom">
                    <IconButton
                      onClick={() =>
                        verEnviarPDFenvasado(row.original.id_nc, 0)
                      }
                    >
                      <VisibilityOffIcon color="secondary" />
                    </IconButton>
                  </Tooltip>
                )}

                {row.original.estado === 311 && (
                  <Tooltip title="Anular Factura" placement="bottom">
                    <IconButton
                      onClick={() => handleAnularFactura(row.original)}
                    >
                      <BlockIcon color="error" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            );
          }}
        />
        {nuevoPedido && (
          <PedidoCliente
            open={nuevoPedido}
            setOpen={setNuevoPedido}
            actualizar={actualizar}
            cliente={cliente}
          />
        )}
        {anularFactura && (
          <AnularFactura
            open={anularFactura}
            setOpen={setAnularFactura}
            factura={rowFactura}
            onClose={handleCloseAnular}
          />
        )}
      </Container>
    </div>
  );
}

export default PedidosFicha;
